export class IdleEvent
{
    public show: boolean;
    public hasTimedOut: boolean;
    public countdown: number;
    public maxTimeout: number;
}
